"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _GridModule = _interopRequireDefault(require("./GridModule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const GalleryModule = model => {
  return _react.default.createElement(_GridModule.default, _extends({}, model, {
    mediaLayout: "cover",
    maxWidth: "100%"
  }));
};

var _default = GalleryModule;
exports.default = _default;
module.exports = exports.default;